var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeartEmpty = function SvgHeartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#heart_empty_svg__b)",
    fill: "#fff",
    clipPath: "url(#heart_empty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.331 12.047 12 20l7.669-7.953A4.804 4.804 0 0 0 21 8.714C21 6.111 18.965 4 16.454 4a4.465 4.465 0 0 0-3.214 1.38L12 6.668 10.76 5.38A4.465 4.465 0 0 0 7.546 4C5.036 4 3 6.11 3 8.714c0 1.25.479 2.45 1.331 3.333Z",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 20-.72.694.72.747.72-.747L12 20Zm-7.669-7.953-.72.694.72-.694Zm15.338 0-.72-.694.72.694ZM10.76 5.381l-.72.694.72-.694ZM12 6.667l-.72.694a1 1 0 0 0 1.44 0L12 6.667Zm1.24-1.286-.72-.694.72.694Zm-.52 13.925L5.05 11.353l-1.44 1.389 7.67 7.952 1.439-1.388Zm6.229-7.953-7.669 7.953 1.44 1.388 7.668-7.952-1.44-1.389ZM10.04 6.075l1.24 1.286 1.44-1.388-1.24-1.286-1.44 1.388Zm2.68 1.286 1.24-1.286-1.44-1.388-1.24 1.286 1.44 1.388ZM16.454 3a5.465 5.465 0 0 0-3.934 1.687l1.44 1.388A3.465 3.465 0 0 1 16.454 5V3ZM20 8.714c0 .997-.382 1.945-1.051 2.64l1.44 1.388A5.804 5.804 0 0 0 22 8.713h-2Zm2 0C22 5.593 19.551 3 16.454 3v2C18.38 5 20 6.628 20 8.714h2ZM7.546 5c.928 0 1.826.382 2.494 1.075l1.44-1.388A5.465 5.465 0 0 0 7.546 3v2ZM4 8.714C4 6.628 5.621 5 7.546 5V3C4.449 3 2 5.593 2 8.714h2Zm1.051 2.64A3.804 3.804 0 0 1 4 8.713H2c0 1.504.576 2.953 1.612 4.027l1.44-1.388Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart_empty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "heart_empty_svg__b",
    x: -2,
    y: -1,
    width: 28,
    height: 26.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 2,
    floodColor: "#000000",
    floodOpacity: 0.15
  })))));
};

export default SvgHeartEmpty;